'use es6';

export const POST = 'post';
export const LISTING = 'listing';